import { Component, Input } from '@angular/core';
import { PickupItemViewModel } from '../reservation.page';

@Component({
    selector: 'app-pickup-overview-item[item]',
    styles: [`
    :host {
      display: block;
    }
    .email-container {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  `],
    template: `
    <div class="d-none d-md-flex flex-row pt-3 pb-3 align-items-center">
      <div class="d-flex align-items-center col-6">
        <div
          class="product-image-placeholder border-medium border bg-white w-48px h-48px me-2 position-relative flex-shrink-0 square-image"
          [style.background-image]="item.product.imageUrl && 'url(' + item.product.imageUrl + ')'">
          <div class="position-absolute start-100 translate-middle badge rounded-pill bg-info">
            {{item.product.quantity}}
          </div>
        </div>
        <span class="mx-2">
          {{item.product.title}}
        </span>
      </div>
      <div class="flex-column d-flex align-items-end ps-3 col-3 pe-3">
        <span class="flex-row fs-6 fw-bold text-end">
          {{item.product.code}}
        </span>
      </div>
      <div class="flex-column d-flex align-items-end ps-3 col-3 pe-3">
        <span class="flex-row fs-6 text-info fw-bold text-end">
          {{item.product.price | currency}}
        </span>
      </div>
    </div>

    <div class="d-flex d-md-none flex-row pt-3 pb-3 align-items-center justify-content-between">
      <div class="d-flex align-items-center overflow-x-hidden">
        <div
          class="product-image-placeholder border-medium border bg-white w-48px h-48px me-2 position-relative flex-shrink-0 square-image"
          [style.background-image]="item.product.imageUrl && 'url(' + item.product.imageUrl + ')'">
          <div class="position-absolute start-100 translate-middle badge rounded-pill bg-info">
            {{item.product.quantity}}
          </div>
        </div>

        <div class="overflow-hidden d-flex flex-column">
          <span class="ps-2">{{item.product.title}}</span>
        </div>

        <div class="overflow-hidden d-flex flex-column">
          <span class="ps-2">{{item.product.code}}</span>
        </div>

      </div>
      <div class="ps-2">
        <span class="fs-6 text-info fw-bold text-end">{{item.product.price | currency}}</span>
      </div>

    </div>
  `,
    standalone: false
})
export class PickupOverviewItemComponent {
  @Input() item!: PickupItemViewModel;
}
